import * as React from "react";
import { PaletteColor, useThemePaletteColor } from "./types";

export default ({ style, color = "primary" }: { style?: React.CSSProperties; color?: PaletteColor }) => {
    const colorVal = useThemePaletteColor(color);

    return (
        <svg version="1.0" width="64px" height="64px" viewBox="0 0 128 128" style={style}>
            <g>
                <circle cx="16" cy="64" r="16" fill={colorVal} />
                <circle cx="16" cy="64" r="14.344" fill={colorVal} transform="rotate(45 64 64)" />
                <circle cx="16" cy="64" r="12.531" fill={colorVal} transform="rotate(90 64 64)" />
                <circle cx="16" cy="64" r="10.75" fill={colorVal} transform="rotate(135 64 64)" />
                <circle cx="16" cy="64" r="10.063" fill={colorVal} transform="rotate(180 64 64)" />
                <circle cx="16" cy="64" r="8.063" fill={colorVal} transform="rotate(225 64 64)" />
                <circle cx="16" cy="64" r="6.438" fill={colorVal} transform="rotate(270 64 64)" />
                <circle cx="16" cy="64" r="5.375" fill={colorVal} transform="rotate(315 64 64)" />
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64"
                    calcMode="discrete"
                    dur="720ms"
                    repeatCount="indefinite"
                ></animateTransform>
            </g>
        </svg>
    );
};
